export const GET_MARKETING_SEGMENTS_CUSTOMERS_START = 'GET_MARKETING_SEGMENTS_CUSTOMERS_START';
export const GET_MARKETING_SEGMENTS_CUSTOMERS_SUCCESS = 'GET_MARKETING_SEGMENTS_CUSTOMERS_SUCCESS';
export const GET_MARKETING_SEGMENTS_CUSTOMERS_FAILED = 'GET_MARKETING_SEGMENTS_CUSTOMERS_FAILED';

export const GET_EDITABLE_SEGMENTS_CUSTOMER_START = 'GET_EDITABLE_SEGMENTS_CUSTOMER_START';
export const GET_EDITABLE_SEGMENTS_CUSTOMER_SUCCESS = 'GET_EDITABLE_SEGMENTS_CUSTOMER_SUCCESS';
export const GET_EDITABLE_SEGMENTS_CUSTOMER_FAILED = 'GET_EDITABLE_SEGMENTS_CUSTOMER_FAILED';

export const EDIT_MARKETING_SEGMENTS_CUSTOMER_START = 'EDIT_MARKETING_SEGMENTS_CUSTOMER_START';
export const EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS = 'EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS';
export const EDIT_MARKETING_SEGMENTS_CUSTOMER_FAILED = 'EDIT_MARKETING_SEGMENTS_CUSTOMER_FAILED';

export const getMarketingSegmentsCustomersStart = () => ({
  type: GET_MARKETING_SEGMENTS_CUSTOMERS_START,
});

export const getMarketingSegmentsCustomersSuccess = (data) => ({
  type: GET_MARKETING_SEGMENTS_CUSTOMERS_SUCCESS,
  data
});

export const getMarketingSegmentsCustomersFailed = (error) => ({
  type: GET_MARKETING_SEGMENTS_CUSTOMERS_FAILED,
  error
});

export const getEditableSegmentsCustomerStart = () => ({
  type: GET_EDITABLE_SEGMENTS_CUSTOMER_START
});

export const getEditableSegmentsCustomerSuccess = (data) => ({
  type: GET_EDITABLE_SEGMENTS_CUSTOMER_SUCCESS,
  data
});

export const getEditableSegmentsCustomerFailed = (error) =>  ({
  type: GET_EDITABLE_SEGMENTS_CUSTOMER_FAILED,
  error
});

export const editMarketingSegmentsCustomerStart = () => ({
  type: EDIT_MARKETING_SEGMENTS_CUSTOMER_START,
});

export const editMarketingSegmentsCustomerSuccess = (data) => ({
  type: EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS,
  data
});

export const editMarketingSegmentsCustomerFailed = (error) => ({
  type: EDIT_MARKETING_SEGMENTS_CUSTOMER_FAILED,
  error
});
